import { UAMeasuresService } from "../service/asyncBatchUAMeasuresService";
import * as validations from "../utils/validations";
import { MeasurmentDate } from "../types/app.interfaces";
export class UAMeasuresFunctions {
  fnBurgissUniverseCalcIRRPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    const localCurrency = validations.validateUAcurrencyParam(currency);
    if (localCurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    if (startDate != null) {
      startDate = validations.isValidBeginDate(startDate);
      if (startDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date Date parameter";
      }
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRRPercentile(
      peergroupID,
      percentile,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_QTDPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    const localCurrency = validations.validateUAcurrencyParam(currency);
    if (localCurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_QTDPercentile(
      peergroupID,
      percentile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_YTDPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    const localCurrency = validations.validateUAcurrencyParam(currency);
    if (localCurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_YTDPercentile(
      peergroupID,
      percentile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_1YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    const localCurrency = validations.validateUAcurrencyParam(currency);
    if (localCurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_1YearPercentile(
      peergroupID,
      percentile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_3YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    const localCurrency = validations.validateUAcurrencyParam(currency);
    if (localCurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_3YearPercentile(
      peergroupID,
      percentile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_5YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    const localCurrency = validations.validateUAcurrencyParam(currency);
    if (localCurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_5YearPercentile(
      peergroupID,
      percentile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_10YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    const localCurrency = validations.validateUAcurrencyParam(currency);
    if (localCurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcIRR_10YearPercentile(
      peergroupID,
      percentile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_15YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    const localCurrency = validations.validateUAcurrencyParam(currency);
    if (localCurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_15YearPercentile(
      peergroupID,
      percentile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_20YearPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    const localCurrency = validations.validateUAcurrencyParam(currency);
    if (localCurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_20YearPercentile(
      peergroupID,
      percentile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcDPIPercentile(
    peergroupID: any[][],
    percentile: any,
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    if (peergroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    percentile = validations.isValidPercentile(percentile);
    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    const localCurrency = validations.validateUAcurrencyParam(currency);
    if (localCurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }

    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcDPIPercentile(
      peergroupID,
      percentile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcNetCashFlowPercentile(
    peerGroupID: any[][],
    percentile: any,
    currency: any,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    percentile = validations.isValidPercentile(percentile);

    if (percentile == "0") {
      return "Mandatory Required parameters not defined";
    }
    if (percentile == "-1") {
      return "#INVALIDPARAMETERS - Percentile not supported";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    let validStartDate: any = new Date(0);
    let validEndtDate: any = new Date(0);

    if (startDate != null) {
      startDate = validations.isValidDate(startDate);
      if (startDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date parameter";
      }
      const dSDate: boolean = validations.searchedDateInMeasurementDate(startDate, "S");
      validStartDate = dSDate == true ? startDate : new Date(0);
      if (validStartDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
    } else {
      validStartDate = startDate;
    }

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    const dateCmp: boolean = validations.dateCompare(validStartDate, validEndtDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    return new UAMeasuresService().burgissUniverseCalcNetCashFlowPercentile(
      peerGroupID,
      percentile,
      currency,
      validStartDate,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcGSS_DirectAlphaPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    uaCurrency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    uaCurrency = validations.validateUAcurrencyParam(uaCurrency);
    if (uaCurrency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcGSS_DirectAlphaPercentile(
      peerGroupId,
      percenTile,
      uaCurrency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcKS_PMEPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    uaCurrency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    uaCurrency = validations.validateUAcurrencyParam(uaCurrency);
    if (uaCurrency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcKS_PMEPercentile(
      peerGroupId,
      percenTile,
      uaCurrency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcLN_ICMIRRPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    uaCurrency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    uaCurrency = validations.validateUAcurrencyParam(uaCurrency);
    if (uaCurrency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcLN_ICMIRRPercentile(
      peerGroupId,
      percenTile,
      uaCurrency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcLN_ICMIRRSpreadPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    uaCurrency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    uaCurrency = validations.validateUAcurrencyParam(uaCurrency);
    if (uaCurrency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcLN_ICMIRRSpreadPercentile(
      peerGroupId,
      percenTile,
      uaCurrency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcLN_ICMValuationSpreadPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    uaCurrency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    uaCurrency = validations.validateUAcurrencyParam(uaCurrency);
    if (uaCurrency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcLN_ICMValuationSpreadPercentile(
      peerGroupId,
      percenTile,
      uaCurrency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcMIRRPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcMIRRPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcRIRRPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const startDateValidation = validations.isValidBeginDate(startDate);
    if (startDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const endDateValidation = validations.isValidEndDate(endDate);
    if (endDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDateValidation, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(startDateValidation, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? startDateValidation : new Date(0);
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? defaultMeasuremntDateValues.endDates
          : "";
    } else if (eDate == true) {
      endDate = endDateValidation;
    }
    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcRIRRPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcDistributionsPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const startDateValidation = validations.isValidBeginDate(startDate);
    if (startDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const endDateValidation = validations.isValidEndDate(endDate);
    if (endDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDateValidation, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(startDateValidation, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? startDateValidation : new Date(0);
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? defaultMeasuremntDateValues.endDates
          : "";
    } else if (eDate == true) {
      endDate = endDateValidation;
    }
    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcDistributionsPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcNetCashFlowPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const startDateValidation = validations.isValidBeginDate(startDate);
    if (startDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const endDateValidation = validations.isValidEndDate(endDate);
    if (endDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDateValidation, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(startDateValidation, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? startDateValidation : new Date(0);
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? defaultMeasuremntDateValues.endDates
          : "";
    } else if (eDate == true) {
      endDate = endDateValidation;
    }
    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcNetCashFlowPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcPaidInCapitalPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const startDateValidation = validations.isValidBeginDate(startDate);
    if (startDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const endDateValidation = validations.isValidEndDate(endDate);
    if (endDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDateValidation, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(startDateValidation, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? startDateValidation : new Date(0);
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? defaultMeasuremntDateValues.endDates
          : "";
    } else if (eDate == true) {
      endDate = endDateValidation;
    }
    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcPaidInCapitalPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcGSS_DirectAlphaPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    index?: string,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }
    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcGSS_DirectAlphaPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcTWRR_QTDPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcTWRR_QTDPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_NWPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_NWPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRRPooled(
    peerGroupID: any[][],
    currency: any,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);
    let validStartDate: any = new Date(0);

    if (startDate != null) {
      startDate = validations.isValidDate(startDate);
      if (startDate === false) {
        return "#INVALIDPARAMETERS - Invalid Start Date parameter";
      }
      const dSDate: boolean = validations.searchedDateInMeasurementDate(startDate, "S");
      validStartDate = dSDate == true ? startDate : new Date(0);
      if (validStartDate.year == 1) {
        return "#INVALIDPARAMETERS - Invalid start Date parameter";
      }
    } else {
      validStartDate = startDate;
    }

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    const dateCmp: boolean = validations.dateCompare(validStartDate, validEndtDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    return new UAMeasuresService().burgissUniverseCalcIRRPooled(
      peerGroupID,
      currency,
      validStartDate,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_QTDPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_QTDPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_YTDPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_QTDPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_1YearPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_1YearPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_3YearPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_3YearPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_5YearPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_5YearPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_10YearPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_10YearPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_15YearPooled(
    peerGroupID: any[][],
    currency: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_15YearPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcIRR_20YearPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcIRR_20YearPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcDPIPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcDPIPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcRVPIPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcRVPIPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcTVPIPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcTVPIPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcValuationPooled(
    peerGroupID: any[][],
    currency: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupID = validations.getSingleOrRangeValues(peerGroupID, filter);
    if (peerGroupID == null) {
      return "Errinvesid" + " " + "Required parameters not defined";
    }

    let index = "";
    index = validations.validIndexId(index);

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);

    if (returnConstituentCount == "-1") {
      return "#INVALIDPARAMETERS - returnConstituentCount not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);

    if (currency.toString().includes("Invalid")) {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate: MeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }

    return new UAMeasuresService().burgissUniverseCalcValuationPooled(
      peerGroupID,
      currency,
      validEndtDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcKS_PMEPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcKS_PMEPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcLN_ICMIRRPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcLN_ICMIRRPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcLN_ICMIRRSpreadPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcLN_ICMIRRSpreadPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcLN_ICMValuationSpreadPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    index?: string,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }
    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }

    return new UAMeasuresService().burgissUniverseCalcLN_ICMValuationSpreadPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      index,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcCapitalizationPooled(
    peerGroupId?: any[][],
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }

    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcCapitalizationPooled(
      peerGroupId,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcDistributionsPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcDistributionsPercentile(
      peerGroupId,
      percenTile,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcMIRRPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    startDate?: any,
    endDate?: any,
    index?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const startDateValidation = validations.isValidDate(startDate);
    if (startDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const endDateValidation = validations.isValidDate(endDate);
    if (endDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDateValidation, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(startDateValidation, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? startDateValidation : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDateValidation : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }
    index = validations.validIndexId(index);
    if (index == "NaN") {
      return "#INVALIDPARAMETERS - Invalid format for IndexID parameter";
    }
    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcMIRRPercentile(
      peerGroupId,
      percenTile,
      currency,
      startDate,
      endDate,
      index,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcPaidInCapitalPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcPaidInCapitalPercentile(
      peerGroupId,
      percenTile,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcRIRRPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    startDate?: any,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcRIRRPercentile(
      peerGroupId,
      percenTile,
      currency,
      startDate,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcRVPIPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcRVPIPercentile(
      peerGroupId,
      percenTile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcTVPIPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcTVPIPercentile(
      peerGroupId,
      percenTile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
  fnBurgissUniverseCalcValuationPercentile(
    peerGroupId?: any[][],
    percenTile?: any,
    currency?: string,
    endDate?: any,
    returnConstituentCount?: any,
    filter?: any,
    uniqueCellId?: string
  ) {
    const minDate = new Date(0).toLocaleDateString();
    peerGroupId = validations.getSingleOrRangeValues(peerGroupId, filter);
    if (peerGroupId.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + peerGroupId.toString().replace("Error", "");
    } else if (peerGroupId.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Peer Group ID is defined.";
    } else if (peerGroupId.toString().includes(",")) {
      return "#INVALIDPARAMETERS - Pooled peer group analysis not supported";
    }
    percenTile = validations.isValidPercentile(percenTile);
    if (percenTile.toString() === "-1" || percenTile.toString() === "0") {
      return percenTile.toString() === "0"
        ? "Mandatory Required parameters not defined"
        : "#INVALIDPARAMETERS - FormaterrorPercentile not supported";
    }
    currency = validations.validateUAcurrencyParam(currency);
    if (currency == "Invalid") {
      return "#INVALIDPARAMETERS - Currency not supported";
    }
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    endDate = validations.isValidEndDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? endDate : minDate;
    }

    returnConstituentCount = validations.returnConstituentCount(returnConstituentCount);
    if (returnConstituentCount === "-1") {
      return "#INVALIDPARAMETERS - Return Constituent Count parameter not supported";
    }

    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    return new UAMeasuresService().burgissUniverseCalcValuationPercentile(
      peerGroupId,
      percenTile,
      currency,
      endDate,
      returnConstituentCount,
      filter,
      uniqueCellId
    );
  }
}
